import { render, staticRenderFns } from "./grant.vue?vue&type=template&id=06ef7992&scoped=true"
import script from "./grant.vue?vue&type=script&lang=ts"
export * from "./grant.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ef7992",
  null
  
)

export default component.exports